"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("./form");
exports.FerpaWaiverComponent = form_1.FerpaWaiverComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9GZXJwYVdhaXZlci9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOztBQUFBLCtCQUEyQztBQUFuQyxzQ0FBQSxvQkFBb0IsQ0FBQSJ9